



















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Message } from "@/services/datatypes";
import { chatSentTimeSince } from "@/utils/utils";
import { PUBLIC_VIEWER_POSTER_NAME_SUFFIX } from "@/services/constants";

@Component({
  components: {},
})
export default class ChatMessage extends Vue {
  @Prop() readonly message!: Message;
  @Prop() readonly isTimeSince!: boolean;

  get isJinroChat(): boolean {
    if (!this.message || !this.message.chatType) {
      return false;
    }
    return this.message.chatType === "jinro";
  }

  get suffix(): string {
    return PUBLIC_VIEWER_POSTER_NAME_SUFFIX;
  }

  chatName(message: Message): string {
    if (!message.fromPublicViewing) {
      return message.playerName;
    }
    return message.fromPublicViewing
      ? message.playerName + this.suffix
      : message.playerName;
  }

  timeCreated(timeCreated: firebase.firestore.Timestamp): string {
    if (!timeCreated) {
      return "";
    }
    const time = timeCreated.toDate();

    if (this.isTimeSince) {
      return chatSentTimeSince(time);
    }
    return `${time.toLocaleString()}`;
  }
}
